// extracted by mini-css-extract-plugin
export default {"navLinkCover":"sidebar_navLinkCover__vZ4Hr"};